import Visual from './Visual.vue'

export default Visual
